// Our server accept number types of card
const UNRECOGRNIZED_TYPE = 0
const CARD_TYPE_MAP = {
  ambiguous: 1,
  'american-express': 2,
  jcb: 3,
  visa: 4,
  mastercard: 5,
  discover: 6,
  maestro: 7,
  unionpay: 8,
  'diners-club': 9,
}

// Convert brain3 card type to server type
export const mapCardTypeToServer = type => {
  if (!type) return UNRECOGRNIZED_TYPE
  const serverType = CARD_TYPE_MAP[type.toLowerCase()]
  return serverType || UNRECOGRNIZED_TYPE
}
